import { Component } from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    selector: 'property-description-page',
    templateUrl: './property-description-page.component.html',
    styleUrls: ['./property-description-page.component.scss'],
    standalone: false
})
export class PropertyDescriptionPageComponent extends PropertyPageBase {
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyDescription, draftFacade, routerFacade);
    }
}
